var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12",attrs:{"align":"center"}},[_c('img',{attrs:{"src":"/assets/img/404notfound.jpg"}})])
}]

export { render, staticRenderFns }